<template>
  <kt-panel>
    <div class="create-services">
      <router-link to="/factors" class="mr-2">
        <button class="btn btn-success">بازگشت</button>
      </router-link>
    </div>
    <form
      @submit.prevent="submitRequest($event, query)"
      id="single-request-form"
      class="kt-form p-3 my-4"
    >
      <div
        class="container p-3 pt-5 my-4 border in-border-header"
        style="padding-top: 1.5rem !important"
      >
        <kt-form-section is_first>
          <div class="section-header">ایجاد فاکتور</div>
          <kt-row class="p-2">
            <kt-col lg="8" md="8" xs="12">
              <kt-form-group>
                <div class="d-flex align-items-center w-75">
                  <div class="dropdown w-75">
                    <button
                      class="btn btn-secondary dropdown-toggle w-75"
                      type="button"
                      id="dropdownMenu2"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      {{ buttonText() }}
                    </button>
                    <div class="dropdown-menu w-75" aria-labelledby="dropdownMenu2">
                        <button
                            class="dropdown-item text-dark w-100 router-link-white"
                            type="button"
                            @click="general()"
                        >
                            فاکتور عمومی
                        </button>
                        <button
                        class="dropdown-item text-dark w-100 router-link-white"
                        type="button"
                        @click="simple()"
                      >
                        فاکتور ساده یک بار مصرف
                      </button>
                        <button
                        class="dropdown-item text-dark w-100 router-link-white"
                        type="button"
                        @click="timeline()"
                      >
                        فاکتور زمان بندی شده یک بار مصرف
                      </button>
                    </div>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >نام فاکتور
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="title"
                    name="title"
                    aria-describedby="basic-addon1"
                    v-model="query.title"
                    @change="errors.title = null"
                  />
                  <div v-if="errors.title" class="text-danger text-tiny">{{ errors.title }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >شماره فاکتور
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="code"
                    name="code"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.code"
                    @change="errors.code = null"
                  />
                  <div v-if="errors.code" class="text-danger text-tiny">{{ errors.code }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block" v-if="mustSelectCustomerFormat() === false">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >مشتریان
                      <span class="text-danger">*</span>
                      <span>
                        <router-link
                          to="/online-factor-customer-create/customer-factor"
                          target="_blank"
                          class="badge badge-success mx-3 p-2"
                        >
                          + ایجاد مشتری
                        </router-link>
                      </span>
                    </span>
                  </div>
                  <div class="d-block" v-else>
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="customer-format"
                      >قالب مشتریان
                      <span class="text-danger">*</span>
                      <span>
                        <router-link
                          to="/online-factor-customer-format-create"
                          target="_blank"
                          class="badge badge-success mx-3 p-2"
                        >
                          + ایجاد قالب مشتری
                        </router-link>
                      </span>
                    </span>
                  </div>
                  <v-select
                    v-if="mustSelectCustomerFormat() === false"
                    v-model="query.customers_id"
                    class="vSelect form-control vSelect-Dark-theme"
                    name="customers_id"
                    :options="optionsCustomer"
                    multiple
                    :filterable="false"
                    @search="onSearchCustomer"
                    :getOptionLabel="(customer) => customer.id"
                  >
                    <template slot="no-options"> مشتری مورد نظر را جستجو کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center text-dark">
                        {{ options.title }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.title }}
                      </div>
                    </template>
                  </v-select>
                  <v-select
                    v-else
                    v-model="query.customer_format_id"
                    class="vSelect form-control vSelect-Dark-theme"
                    name="customer_format_it"
                    :options="optionsCustomerFormat"
                    :filterable="false"
                    @search="onSearchCustomerFormat"
                    :getOptionLabel="(customer_format) => customer_format.id"
                  >
                    <template slot="no-options">قالب مشتری مورد نظر را جستجو کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center text-dark">
                        {{ options.name }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div style="background-color: whitesmoke; padding: 1px 1px"
                           class="selected d-flex align-items-center">
                        {{ options.name }}
                      </div>
                    </template>
                  </v-select>
                  <div v-if="errors.customers_id && query.customers_id.length === 0" class="text-danger text-tiny">{{ errors.customers_id }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_simple">
              <kt-form-group>
                <div class="d-block">
                    <span
                        class="d-flex align-items-center my-1 bg-white text-dark"
                        id="basic-addon1"
                    >تاریخ ارسال
                      <span class="text-danger" v-if="factor_type_simple">*</span>
                    </span>
                </div>
                <date-picker
                  v-model="query.simple_sent_date"
                  name="simple_sent_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="YYYY-MM-DD"
                  id="simple_send_date"
                  :clearable="true"
                  @change="errors.simple_sent_date = null"
                />
                <div v-if="errors.simple_sent_date" class="text-danger text-tiny">{{ errors.simple_sent_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_simple">
              <kt-form-group>
                <div class="d-block">
                    <span
                        class="d-flex align-items-center my-1 bg-white text-dark"
                        id="basic-addon1"
                    >تاریخ سر رسید
                      <span class="text-danger" v-if="factor_type_simple">*</span>
                    </span>
                </div>
                <date-picker
                  v-model="query.simple_due_date"
                  name="simple_due_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="YYYY-MM-DD"
                  id="simple_due_date"
                  :clearable="true"
                  @change="errors.simple_due_date = null"
                />
                <div v-if="errors.simple_due_date" class="text-danger text-tiny">{{ errors.simple_due_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="d-block">
                  <span
                    class="d-flex align-items-center my-1 bg-white text-dark"
                    id="basic-addon1"
                    >شروع از تاریخ
                    <span class="text-danger">*</span>
                  </span>
                </div>
                <date-picker
                  v-model="query.scheduler_start_date"
                  color="#00c1a4"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="dddd jDD jMMMM jYYYY"
                  placeholder="شروع از تاریخ"
                  id="simple_due_date"
                  :clearable="true"
                  @change="errors.scheduler_start_date = null"
                />
                <div v-if="errors.scheduler_start_date" class="text-danger text-tiny">{{ errors.scheduler_start_date }}</div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="6" md="6" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >دفعات ارسال
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_count"
                    name="scheduler_repeat_cycle_count"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_count"
                    @change="errors.scheduler_repeat_cycle_count = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_count" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_count }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_days"
            >
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_weeks"
            >
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_months"
            >
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col
              lg="9"
              md="9"
              xs="9"
              v-if="factor_type_timeline && factor_timeline_years"
            >
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >تکرار در هر
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_repeat_cycle_days"
                    name="scheduler_repeat_cycle_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    v-model="query.scheduler_repeat_cycle_days"
                    @change="errors.scheduler_repeat_cycle_days = null"
                  />
                  <div v-if="errors.scheduler_repeat_cycle_days" class="text-danger text-tiny">{{ errors.scheduler_repeat_cycle_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="3" md="3" xs="3" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="d-block">
                  <span
                    class="d-flex align-items-center my-1 bg-white text-dark"
                    id="basic-addon1"
                    >{{
                      factor_timeline_days
                        ? "روز"
                        : factor_timeline_weeks
                        ? "هفته"
                        : factor_timeline_months
                        ? "ماه"
                        : factor_timeline_years
                        ? "سال"
                        : ""
                    }}
                    <span class="text-danger">*</span>
                  </span>
                </div>
                <div class="dropdown w-100">
                  <button
                    class="btn btn-secondary dropdown-toggle w-100"
                    type="button"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{
                      factor_timeline_days
                        ? "روز"
                        : factor_timeline_weeks
                        ? "هفته"
                        : factor_timeline_months
                        ? "ماه"
                        : factor_timeline_years
                        ? "سال"
                        : ""
                    }}
                  </button>
                  <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                    <button
                      class="dropdown-item text-dark router-link-white"
                      type="button"
                      @click="factorDays()"
                    >
                      روز
                    </button>
                    <button
                      class="dropdown-item text-dark router-link-white"
                      type="button"
                      @click="factorWeeks()"
                    >
                      هفته
                    </button>
                    <button
                      class="dropdown-item text-dark router-link-white"
                      type="button"
                      @click="factorMonths()"
                    >
                      ماه
                    </button>
                    <button
                      class="dropdown-item text-dark router-link-white"
                      type="button"
                      @click="factorYears()"
                    >
                      سال
                    </button>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12" v-if="factor_type_timeline">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >سر رسید فاکتور بعد از
                      <span class="text-danger" >*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="scheduler_due_days"
                    name="scheduler_due_days"
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                    placeholder="روز"
                    v-model="query.scheduler_due_days"
                    @change="errors.scheduler_due_days = null"
                  />
                  <div v-if="errors.scheduler_due_days" class="text-danger text-tiny">{{ errors.scheduler_due_days }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >محصولات
                      <span class="text-danger">*</span>
                      <span>
                        <router-link
                          to="/online-factor-item-create/item-factor"
                          target="_blank"
                          class="badge badge-success mx-3 p-2"
                        >
                          + ایجاد محصول
                        </router-link>
                      </span>
                    </span>
                  </div>
                  <v-select
                    v-model="query.items"
                    id="items"
                    name="items"
                    @input="setSelectedForItem"
                    class="vSelect form-control vSelect-Dark-theme"
                    :options="optionsItem"
                    multiple
                    :filterable="false"
                    @search="onSearchItem"
                    :getOptionLabel="(item) => item.item_id"
                    :selectable="optionsItem => optionsItem.quantity !== 0"
                    :class="{'text-red': optionsItem => optionsItem.quantity === 0}"
                  >
                    <template slot="no-options"> محصول مورد نظر را جستجو کنید </template>
                    <template slot="option" slot-scope="options">
                      <div
                          class="d-flex align-items-center"
                          :class="{ 'text-danger': options.quantity === 0 , 'text-dark': options.quantity !== 0}"
                      >
                        <span v-show="options.quantity === 0" class="text-danger px-2">ناموجود -</span><span>{{ options.title }}</span>
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.title }}
                      </div>
                    </template>
                  </v-select>
                  <div v-if="errors.items && query.items.length === 0" class="text-danger text-tiny">{{ errors.items }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <div
              class="col-md-4 my-1"
              v-for="(item, idx) in query.items"
              :key="idx"
            >
              <div class="card col-md-12 p-0 h-100 factor-payment-bg-dark">
                <div
                  class="card-body d-flex flex-column align-items-center jsutify-content-center text-center"
                >
                  <div>
                    <img
                      v-if="item.image === null"
                      src="../../../assets/media/item.png"
                      alt=""
                      class="img-fluid"
                      style="height: 150px"
                    />
                    <img v-else :src="`${item.image}`" alt="" />
                  </div>
                  <div
                    class="d-flex flex-column align-items-center justify-content-between text-dark router-link-white"
                  >
                    <div class="text-dark py-5 w-100 router-link-white" id="itemsTitle">
                      {{ item.title }}
                    </div>
                    <p>{{ Number(item.amount).toLocaleString() + " ریال" }}</p>
                  </div>
                </div>
                <div class="card-body d-flex justify-content-center align-items-center card-b-t w-100">
                  <div v-if="!factor_type_general" class="col-md-3">
                    <button
                      type="button"
                      class="btn text-primary w-100"
                      @click="increase(item, idx)"
                      style="text-align: center"
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-md-3">
                    <span class="text-center form-control border-0 bg-secondary" style="width: 50px">{{ item.number }}</span>
                  </div>
                  <div v-if="!factor_type_general" class="col-md-3">
                    <button
                      type="button"
                      class="btn text-primary w-100"
                      @click="decrease(item, idx)"
                      style="text-align: center"
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </div>
                  <div class="col-md-3">
                    <button
                      type="button"
                      class="btn text-danger w-100"
                      @click="removeQ(item)"
                      style="text-align: center"
                    >
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
                <div v-if="factor_type_general" class="card-body d-flex justify-content-center align-items-center card-b-t w-100">
                  <div class="d-flex justify-content-between w-100">
                    <label class="form-check-label" for="items_count">امکان انتخاب تعداد کالا توسط کاربر</label>
                    <label class="switch">
                      <input
                          type="checkbox"
                          id="items_count"
                          v-model="item.quantity_selection"
                      />
                      <span class="slider round"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >هزینه حمل و نقل
                      <span class="text-danger" v-if="factor_type_simple">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    id="shipping_cost"
                    name="shipping_cost"
                    class="form-control"
                    aria-describedby="basic-addon1"
                    v-model="query.shipping_cost"
                    @change="errors.shipping_cost = null"
                  />
                  <div v-if="errors.shipping_cost" class="text-danger text-tiny">{{ errors.shipping_cost }}</div>
                </div>
                <span class="badge badge-light my-2 d-block w-25">
                  {{ Number(query.shipping_cost).toLocaleString() + " ریال" }}
                </span>
              </kt-form-group>
            </kt-col>
            <kt-col v-if="!factor_type_general" lg="3" md="3" xs="12">
              <kt-form-group>
                <div class="d-block">
                    <span
                      class="d-flex align-items-center my-1 bg-white text-dark"
                      id="basic-addon1"
                      >نوع تخفیف
                    </span>
                  </div>
                <div class="dropdown w-100">
                  <button
                    class="btn btn-secondary dropdown-toggle w-100"
                    type="button"
                    id="dropdownMenu2"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    {{ factor_discount_amount ? " تخفیف به مبلغ " : " تخفیف به درصد " }}
                  </button>
                  <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                    <button
                      class="dropdown-item text-dark w-100 router-link-white"
                      type="button"
                      @click="factorDiscountAmount()"
                    >
                      مبلغ
                    </button>
                    <button
                      class="dropdown-item text-dark w-100 router-link-white"
                      type="button"
                      @click="factorDiscountPercent()"
                    >
                      درصد
                    </button>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col v-if="!factor_type_general && factor_discount_amount" lg="9" md="9" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="d-flex align-items-center bg-white text-dark"
                      id="basic-addon1"
                    >
                      ریال
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    class="form-control w-100"
                    id="discount_amount"
                    name="discount_amount"
                    aria-describedby="basic-addon1"
                    v-model="query.discount_amount"
                    @change="errors.discount_amount = null"
                  />
                  <div v-if="errors.discount_amount" class="text-danger text-tiny">{{ errors.discount_amount }}</div>
                </div>
                <span class="badge badge-light my-2 d-block w-25">{{
                  Number(query.discount_amount).toLocaleString() + " ریال"
                }}</span>
              </kt-form-group>
            </kt-col>
            <kt-col v-if="!factor_type_general && factor_discount_percent" lg="9" md="9" xs="12">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend">
                    <span
                      class="d-flex align-items-center bg-white text-dark"
                      id="basic-addon1"
                    >
                      درصد
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    class="form-control w-100"
                    id="discount_percent"
                    name="discount_percent"
                    aria-describedby="basic-addon1"
                    v-model="query.discount_percent"
                    @change="errors.discount_percent = null"
                  />
                  <div v-if="errors.discount_percent" class="text-danger text-tiny">{{ errors.discount_amount }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col v-if="factor_type_general" lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="mb-3">
                  <div class="d-block">
                    <span
                        class="d-flex align-items-center my-1 bg-white text-dark"
                        id="basic-addon1"
                    >کد تخفیف
                        <router-link
                            to="/online-factor/create-discount"
                            target="_blank"
                            class="badge badge-success mx-3 p-2"
                        >
                          + ایجاد کد تخفیف
                        </router-link>
                    </span>
                  </div>
                  <v-select
                      v-model="query.discounts"
                      id="discounts"
                      name="discounts"
                      class="vSelect form-control vSelect-Dark-theme"
                      :options="optionsDiscounts"
                      multiple
                      :filterable="false"
                      @search="onSearchDiscount"
                      :getOptionLabel="(discount) => discount.id"
                  >
                    <template slot="no-options">کد تخفیف مورد نظر را جستجو کنید </template>
                    <template slot="option" slot-scope="options">
                      <div class="d-flex align-items-center text-dark">
                        {{ options.code }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="options">
                      <div class="selected d-flex align-items-center">
                        {{ options.code }}
                      </div>
                    </template>
                  </v-select>
                  <div v-if="errors.discounts && query.discounts.length === 0" class="text-danger text-tiny">{{ errors.discounts }}</div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <kt-form-group>
                <div class="bg-factor text-dark">
                  <div class="card-body">
                    <div class="d-flex align-item-center justify-content-between">
                      <div>
                        <p class="font-weight-bold router-link-white">قیمت کل محصولات</p>
                        <p class="font-weight-bold router-link-white">هزینه حمل و نقل</p>
                        <p class="font-weight-bold router-link-white">تخفیف</p>
                        <h5 class="font-weight-bold router-link-white">جمع کل</h5>
                      </div>
                      <div>
                        <p class="router-link-white">
                          {{
                            query.items.length === 0
                              ? "0"
                              : Number(itemsAmount).toLocaleString()
                          }}
                          ریال
                        </p>
                        <p class="router-link-white">
                          {{
                            query.shipping_cost === "0"
                              ? "0"
                              : Number(query.shipping_cost).toLocaleString()
                          }}
                          ریال
                        </p>
                        <p v-if="factor_discount_amount" class="router-link-white">
                          {{
                            query.discount_amount === "0"
                              ? "0"
                              : Number(query.discount_amount).toLocaleString()
                          }}
                          ریال
                        </p>
                        <p v-if="factor_discount_percent" class="router-link-white">
                          {{
                            query.discount_percent === "0"
                              ? "0"
                              : Number(query.discount_percent)
                          }}
                          درصد
                        </p>
                        <p class="router-link-white">
                          {{ Number(finalPrice).toLocaleString() }} ریال
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
              <div class="custom-control custom-switch mb-3">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="customSwitch1"
                  v-model="factor_has_message"
                />
                <label class="custom-control-label" for="customSwitch1"
                  >پیغام به مشتری قبل از پرداخت</label
                >
              </div>
            </kt-col>
            <kt-col lg="12" md="12" xs="12" v-if="factor_has_message">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend ml-3">
                    <span
                      class="d-flex align-items-center bg-white text-dark"
                      id="basic-addon1"
                      >پیغام به مشتری قبل از پرداخت
                      <span class="text-danger">*</span>
                    </span>
                  </div>
                  <input
                    type="text"
                    class="form-control"
                    id="message"
                    name="message"
                    aria-describedby="basic-addon1"
                    v-model="query.message"
                  />
                </div>
              </kt-form-group>
            </kt-col>
            <kt-col lg="12" md="12" xs="12">
                <div class="d-flex align-items-center mb-4">
                    <span class="ml-3">فرایند بعد از پرداخت</span>
                    <kt-form-group>
                      <div class="d-flex align-items-center w-100 mt-3">
                          <div class="dropdown w-100">
                              <button
                                  class="btn btn-secondary dropdown-toggle w-100"
                                  type="button"
                                  id="dropdownMenu2"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                              >
                                  {{
                                      factor_rules_type === 1
                                          ? "نمایش رسید بعد از پرداخت"
                                          : "ریدایرکت به لینک بعد از پرداخت"
                                  }}
                              </button>
                              <div class="dropdown-menu w-100" aria-labelledby="dropdownMenu2">
                                  <button
                                      class="dropdown-item text-dark router-link-white"
                                      type="button"
                                      @click="showReceipt()"
                                  >
                                      نمایش رسید بعد از پرداخت
                                  </button>
                                  <button
                                      class="dropdown-item text-dark router-link-white"
                                      type="button"
                                      @click="redirectToLink()"
                                  >
                                      ریدایرکت به لینک بعد از پرداخت
                                  </button>
                              </div>
                          </div>
                      </div>
                    </kt-form-group>
                </div>
            </kt-col>

            <kt-col lg="12" md="12" xs="12" v-if="factor_rules_type == 1">
              <kt-form-group>
                <div class="input-group mb-3">
                  <div class="input-group-prepend ml-3">
                    <span
                      class="d-flex align-items-center bg-white text-dark"
                      id="basic-addon1"
                      >توضیحات رسید:
                    </span>
                  </div>
                  <textarea
                    type="text"
                    id="rules"
                    cols="5"
                    rows="5"
                    name="rules"
                    class="form-control"
                    aria-describedby="basic-addon1"
                    v-model="query.rules"
                  />
                  <div v-if="errors.rules" class="text-danger text-tiny">{{ errors.rules }}</div>
                </div>
              </kt-form-group>
            </kt-col>
             <!-- <kt-col lg="6" md="6" xs="12">
                    <kt-form-group>
                        <kt-form-label for="payment_method">
                          روش پرداخت
                        </kt-form-label>
                        <kt-form-select
                            size="3"
                            id="payment_method"
                            class="form-control"
                            name="payment_method"
                            v-model="query.payment_method"
                        >
                            <option
                                v-bind:value="1"
                            >
                              درگاه پرداخت اینترنتی (IPG)
                            </option>
                            <option
                                v-bind:value="0"
                                :disabled="true"
                            >
                             پرداخت شناسه دار (به زودی)
                            </option>
                        </kt-form-select>

                    </kt-form-group>
                </kt-col> -->

            <kt-col lg="9" md="9" xs="12" v-if="factor_rules_type == 1">
              <kt-form-group>
                  <div class="input-group mb-3 mt-2">
                      <div class="input-group-prepend ml-3">
                        <span
                            class="d-flex align-items-center bg-white text-dark"
                            id="basic-addon1"
                        >لینک رسید:
                        </span>
                      </div>
                      <input
                          type="text"
                          id="receipt_link"
                          name="receipt_link"
                          class="form-control"
                          placeholder="مثال: https://paystar.ir"
                          aria-describedby="basic-addon1"
                          v-model="query.receipt_link"
                      />
                  </div>
                  <div v-if="errors.receipt_link" class="text-danger text-tiny">{{ errors.receipt_link }}</div>
                  </kt-form-group>
              </kt-col>

            <kt-col lg="9" md="9" xs="12" v-if="factor_rules_type == 2">
              <kt-form-group>
                  <div class="input-group mb-3">
                      <div class="input-group-prepend ml-3">
                        <span
                            class="d-flex align-items-center bg-white text-dark"
                            id="basic-addon1"
                        >لینک:<span class="text-danger">*</span>
                        </span>
                      </div>
                      <input
                          type="text"
                          id="link"
                          name="link"
                          class="form-control"
                          placeholder="مثال: https://paystar.ir"
                          aria-describedby="basic-addon1"
                          v-model="query.link"
                      />
                  </div>
                  <div v-if="errors.link" class="text-danger text-tiny">{{ errors.link }}</div>
              </kt-form-group>
            </kt-col>

            <kt-col class="mt-3" lg="12" md="12" xs="12">
              <kt-button
                id="form-btn"
                class="btn btn-success btn-wide text-center py-2"
                type="submit"
                variant="success"
              >
                ارسال فاکتور
              </kt-button>
            </kt-col>
          </kt-row>
        </kt-form-section>
      </div>
    </form>
  </kt-panel>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import toastr from "toastr";
import { KTApp } from "@/plugins/core/app";
import { onlineFactorService } from "@/common/shop.service";

export default {
  props: {
    submitSingleRequest: {
      default: function ($event, query) {},
      type: Function,
    },
  },
  data() {
    return {
      query: {
        is_unlimited: false,
        shipping_cost: 0,
        discount_amount: 0,
        discount_percent: 0,
        customers_id: [],
        customer_format_id: null,
        items: [],
        discounts: [],
        link: null,
        rules: null,
        receipt_link: null,
      },
      customersSelected: [],
      itemsSelected: [],
      optionsCustomer: [],
      optionsDiscounts: [],
      optionsCustomerFormat: [],
      optionsItem: [],
      factor_type_timeline: false,
      factor_type_simple: false,
      factor_type_general: true,
      selectedItem: [],
      factor_timeline_days: true,
      factor_timeline_weeks: false,
      factor_timeline_months: false,
      factor_timeline_years: false,
      factor_discount_amount: true,
      factor_discount_percent: false,
      factor_has_message: false,
      factor_message_type: 1,
      factor_rules_type: 1,
      selects_customer_format: false,
      itemsPrice: "",
      errors: {
        title: null,
        code: null,
        customers_id: null,
        customer_format_id: null,
        items: null,
        shipping_cost: null,
        discount_amount: null,
        discount_percent: null,
        message: null,
        simple_due_date: null,
        simple_sent_date: null,
        rules: null,
        scheduler_start_date: null,
        scheduler_repeat_cycle_days: null,
        scheduler_repeat_cycle_count: null,
        scheduler_due_days: null,
        discounts: null,
        link: null,
        receipt_link: null,
      }
    };
  },
  computed: {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: true,
        rtl: false,
      };

      return toastr;
    },
    finalPrice() {

      var fPrice = 0;
      if (this.factor_discount_amount) {
        //   for amount
        fPrice =
          Number(this.itemsAmount) +
          Number(this.query.shipping_cost) -
          Number(this.query.discount_amount);
      }
      if (this.factor_discount_percent) {
        //   for percent
        fPrice =
          Number(this.itemsAmount) +
          Number(this.query.shipping_cost) -
          ((Number(this.query.shipping_cost) + Number(this.itemsAmount)) *
            Number(this.query.discount_percent)) /
            100;
      }
      return fPrice;
    },
    itemsAmount() {
      var totalAmount = 0;
      this.itemsSelected.map((item) => {
        totalAmount += Number(item.amount) * Number(item.number);
      });
      return totalAmount;
    },
  },
  methods: {
    // SetSelected
    setSelectedForCustomer(value) {
      for (let id in value) {
        this.customersSelected.push(value[id].id);
      }
      function removeDuplicates(arr) {
        return arr.filter((item, index) => arr.indexOf(item) === index);
      }
      this.customersSelected = removeDuplicates(this.customersSelected);
    },
    // For Items Selected
    setSelectedForItem(value) {
      this.itemsSelected = value;
    },
    // OnSearch for Customers
    onSearchCustomer(search, loading) {
      this.errors.customers_id = null
      this.searchForCustomer(loading, search, this);
    },
    //OnSearch for discount
    onSearchDiscount(search, loading) {
      this.errors.discounts = null
      this.searchDiscount(loading, search, this)
    },
    searchDiscount: _.debounce((loading, search, vm) => {
      let params = {
        code: search,
        is_search: 1
      }
      onlineFactorService.getDiscount(params)
          .then(response => {
            vm.optionsDiscounts = response.data.data
          })
    }, 600),
    searchForCustomer: _.debounce((loading, search, vm) => {
      let token = localStorage.getItem("access_token");
      onlineFactorService
        .factorCustomerSearch(search, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          vm.optionsCustomer = res.data;
          loading(false);
        })
        .catch((error) => {
          throw new Error(error)
        });
    }, 600),
    onSearchCustomerFormat(search, loading) {
      this.errors.customer_format_id = null
      this.searchForCustomerFormat(loading, search, this);
    },
    searchForCustomerFormat: _.debounce((loading, search, vm) => {
      onlineFactorService
        .getFactorCustomerFormat({name: search})
        .then((res) => {
          vm.optionsCustomerFormat = res.data.data.data;
          loading(false);
        })
        .catch((error) => {
          throw new Error(error)
        });
    }, 600),
    // OnSearch for Items
    onSearchItem(search, loading) {
      this.errors.items = null
      this.searchForItem(loading, search, this);
    },
    searchForItem: _.debounce((loading, search, vm) => {
      let token = localStorage.getItem("access_token");
      onlineFactorService
        .factorItemSearch(search, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          vm.optionsItem = res.data;
          vm.selectedItem = res.data;
          loading(false);
        })
        .catch((error) => {
          throw new Error(error)
        });
    }, 600),
    currencyFormat(price) {
      price = Math.floor(price / 10);
      const pieces = parseFloat(price).toFixed(0).split("");
      let ii = pieces.length;

      while ((ii -= 3) > 0) {
        pieces.splice(ii, 0, ",");
      }

      return pieces.join("");
    },
    processFile(e) {
      this.factor.file = e.target.files[0];
      let output = document.getElementById("pic_preview");
      output.src = URL.createObjectURL(e.target.files[0]);
      output.onload = function () {
        URL.revokeObjectURL(output.src); // free memory
      };
    },
    submitRequest(e, query) {
      let form = $("#single-request-form");
      let btn = $("#form-btn");
      form.validate({
        rules: {
          title: {
            required: true,
          },
          code: {
            required: false,
          },
          customers_id: {
            required: true,
          },
          items: {
            required: true,
          },
          shipping_cost: {
            required: true,
          },
          discount_amount: {
            required: true,
          },
          message: {
            required: true,
          },
            link: {
                required: () => {
                    return this.factor_rules_type == 2;
                },
            },
          scheduler_start_date: {
            required: true,
          },
          scheduler_repeat_cycle_days: {
            required: true,
          },
          scheduler_repeat_cycle_count: {
            required: true,
          },
          scheduler_due_days: {
            required: true,
          },
        },
      });

      if ((!this.query.simple_due_date || !this.query.simple_sent_date) && this.factor_type_simple) {
        if (!this.query.simple_due_date) {
          this.errors.simple_due_date = 'تکمیل این فیلد اجباری است.'
        }

        if (!this.query.simple_sent_date) {
          this.errors.simple_sent_date = 'تکمیل این فیلد اجباری است.'
        }

        return;
      }

      if (query.items.length === 0 || (query.customers_id.length === 0 && query.customer_format_id.length ===0))
      {
        if (query.items.length === 0)
          this.errors.items = "تکمیل این فیلد اجباری است."

        if (query.customers_id.length === 0)
          this.errors.customers_id = "تکمیل این فیلد اجباری است."

        if (query.customer_format_id.length === 0)
          this.errors.customer_format_id = "تکمیل این فیلد اجباری است."

        return;
      }

      if (! form.valid()) {
          return;
      }

      let items = query.items.map(item => ( {item_id: item.item_id , number: item.number, quantity_selection: item.quantity_selection} ))
      let customers_id = (this.factor_type_simple || this.factor_type_timeline) ? query.customers_id.map(item => item.id) : null
      let customer_format_id = this.factor_type_general ? query.customer_format_id.id : null
      let discounts = this.factor_type_general ? query.discounts.map(item => item.id) : null
      let factor_type = null

      if (this.factor_type_simple) {
        factor_type = 1
      } else if(this.factor_type_timeline) {
        factor_type = 2
      } else {
        factor_type = 3
      }

      let data = {
        title: query.title,
        code: query.code ? query.code : "",
        type: factor_type,
        simple_sent_date: (this.factor_type_simple || this.factor_type_general) ? query.simple_sent_date : "",
        simple_due_date: (this.factor_type_simple || this.factor_type_general) ? query.simple_due_date : "",
        scheduler_start_date: this.factor_type_timeline ? query.scheduler_start_date : "",
        scheduler_repeat_cycle_days:
          this.factor_type_timeline && this.factor_timeline_days
            ? query.scheduler_repeat_cycle_days
            : this.factor_type_timeline && this.factor_timeline_weeks
            ? query.scheduler_repeat_cycle_days * 7
            : this.factor_type_timeline && this.factor_timeline_months
            ? query.scheduler_repeat_cycle_days * 30
            : this.factor_type_timeline && this.factor_timeline_years
            ? query.scheduler_repeat_cycle_days * 365
            : "",
        scheduler_repeat_cycle_count: this.factor_type_timeline
          ? query.scheduler_repeat_cycle_count
          : "",
        scheduler_due_days: this.factor_type_timeline ? query.scheduler_due_days : "",
        shipping_cost: query.shipping_cost ? query.shipping_cost : 0,
        discount_amount: this.factor_discount_amount ? query.discount_amount : "",
        discount_percent: this.factor_discount_percent ? query.discount_percent : "",
        has_message: this.factor_has_message,
        message_type: this.factor_message_type,
        message: this.factor_has_message ? query.message : "",
        rule_type: this.factor_rules_type,
        has_signature: false,
        payment_after_due_date: true,
        customers_id: customers_id,
        customer_format_id: customer_format_id,
        items: items,
        discounts: discounts,
      };

      if (this.factor_rules_type == 1) {
          data.rules = this.query.rules ? this.query.rules : null
          data.receipt_link = this.query.receipt_link ? this.query.receipt_link : null
      }

        if (this.factor_rules_type == 2) {
            data.link = this.query.link
        }

      KTApp.progress(btn);

      let tokenStr = localStorage.getItem("access_token");
      onlineFactorService
        .createFactor(data, { headers: { Authorization: `Bearer ${tokenStr}` } })
        .then((response) => {
          this.$router.push("/factors");
        })
        .catch(({response} ) => {
          if (response.status === 500){
            this.toastr.error('خطای سرور');
            return
          }
          this.toastr.error(response.data.message);
          for (let err in response.data.data) {
            this.errors[err] = response.data.data[err][0]
          }
        })
        .finally((response) => {
          KTApp.unprogress(btn);
        });
    },
    resetData() {
      this.query = {
        is_unlimited: false,
        shipping_cost: 0,
        discount_amount: 0,
        discount_percent: 0,
        customers_id: [],
        customer_format_id: null,
        items: []
      }
      this.errors = {
        title: null,
        code: null,
        customers_id: null,
        customer_format_id: null,
        items: null,
        shipping_cost: null,
        discount_amount: null,
        discount_percent: null,
        message: null,
        simple_due_date: null,
        simple_sent_date: null,
        rules: null,
        scheduler_start_date: null,
        scheduler_repeat_cycle_days: null,
        scheduler_repeat_cycle_count: null,
        scheduler_due_days: null,
      }
    },
    timeline() {
      this.factor_type_timeline = true;
      this.factor_type_simple = false;
      this.factor_type_general = false;
      this.resetData()
    },
    simple() {
      this.factor_type_simple = true;
      this.factor_type_timeline = false;
      this.factor_type_general = false;
      this.resetData()
    },
    general() {
      this.factor_type_simple = false;
      this.factor_type_timeline = false;
      this.factor_type_general = true;
      this.resetData()
    },
    factorDays() {
      this.factor_timeline_days = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_months = false;
      this.factor_timeline_years = false;
    },
    factorWeeks() {
      this.factor_timeline_days = false;
      this.factor_timeline_weeks = true;
      this.factor_timeline_months = false;
      this.factor_timeline_years = false;
    },
    factorMonths() {
      this.factor_timeline_months = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_days = false;
      this.factor_timeline_years = false;
    },
    factorYears() {
      this.factor_timeline_years = true;
      this.factor_timeline_weeks = false;
      this.factor_timeline_days = false;
      this.factor_timeline_months = false;
    },
    openNewTab(path) {
      const url = this.$router.resolve({ path: path }).href;
      window.open(url, '_blank');
    },
    buttonText() {
        if (this.factor_type_general) {
            return 'فاکتور عمومی'
        }

        if (this.factor_type_simple) {
            return 'فاکتور ساده یک بار مصرف'
        }

        if (this.factor_type_timeline) {
            return 'فاکتور زمان بندی شده یک بار مصرف'
        }
    },
    removeQ(item) {
      if (item.number) {
        var findIdx = this.query.items.indexOf(item);
        this.query.items.splice(findIdx, 1);
      } else {
        item.number--;
      }
    },
    decrease(item, index) {
      if (item.number > 1) {
        item.number--;
        this.query.items[index].quantity++
      } else {
        item.number = 1;
      }
    },
    increase(item, index){
      if (this.query.items[index].quantity <= 1){
        this.toastr.error('موجودی محصول مورد نظر کافی نیست!');
      }else {
        item.number++
        this.query.items[index].quantity--
      }
    },
    factorDiscountAmount() {
      this.factor_discount_amount = true;
      this.factor_discount_percent = false;
    },
    factorDiscountPercent() {
      this.factor_discount_amount = false;
      this.factor_discount_percent = true;
    },
    afterPayMsg() {
      this.factor_message_type = 1;
    },
    BeforeandAfterPaymsg() {
      this.factor_message_type = 2;
    },
    showReceipt() {
      this.factor_rules_type = 1;
    },
    redirectToLink() {
      this.factor_rules_type = 2;
    },
    mustSelectCustomerFormat() {
      return this.factor_type_general;
    },
    currentType() {
        if (this.factor_type_general) {
            return 3
        }

        if (this.factor_type_simple) {
            return 1
        }

        if (this.factor_type_timeline) {
            return 2
        }
    }
  },
};
</script>
<style scoped>
.preview_img {
  max-width: 70px;
  max-height: 70px;
  position: absolute;
  top: 10px;
  left: 80px;
}

textarea {
  resize: none;
}

#numberItems {
  text-align: center;
}

.bg-factor {
  border-radius: 11px;
  background: linear-gradient(
    180deg,
    rgba(53, 206, 183, 0.05) 100%,
    rgba(255, 255, 255, 1) 100%
  );
}

.custom-file-upload {
  display: none;
}

.file-label {
  border: 1px dashed gray;
  color: #333;
  height: 100px;
  width: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  cursor: pointer;
}

.btn.dropdown-toggle:after {
  padding-right: 50px;
}

.vSelect {
  --vs-actions-padding: 0;
  --vs-border-color: #fff;
}

.cursor_pointer {
  cursor: pointer;
}

.card {
  border: 1px solid #e9e9e9 !important;
}

.img-border {
  border: 1px solid red;
}

.card-b-t {
  border-top: 1px solid #e9e9e9;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

#itemsTitle {
  font-size: 15px;
  width: 100%;
}

.create-services {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-end;
}

.text-tiny {
  font-size: 11px;
}

@media screen and (max-width: 1000px) {
  .btn.dropdown-toggle:after {
    padding-right: 30px;
  }
}
</style>
